import { Box, Icon, IconProps, Input, InputProps, Pressable } from '@rbilabs/universal-components';

import { ZIndex, getDesignToken } from 'styles/constants';

export const Container = Box.withConfig({
  _ios: {
    zIndex: ZIndex.TOP,
  },
  _web: { zIndex: ZIndex.TOP },
});

export const StyledAddressInput = Input.withConfig<{ inputCustomProps?: InputProps }>(
  ({ inputCustomProps = {} }) => ({
    fontSize: 'md',
    boxSize: '$12',
    color: inputCustomProps?.isDisabled
      ? getDesignToken('text-disabled')
      : getDesignToken('text-default'),
    backgroundColor: inputCustomProps?.isDisabled ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
    borderColor: getDesignToken('border-color-input-default'),
    borderWidth: 1,
    isDisabled: inputCustomProps?.isDisabled,
    ...inputCustomProps,
  })
);

export const StyledInputIcon = Icon.withConfig<{ rightIconCustomProps?: IconProps }>(
  ({ rightIconCustomProps }) =>
    rightIconCustomProps
      ? rightIconCustomProps
      : {
          marginRight: '$4',
          color: getDesignToken('icon-form-input-default'),
        }
);

export const OptionsListWrapper = Box.withConfig({
  shadow: '2',
  _android: {
    style: {
      elevation: ZIndex.TOP,
    },
  },
  width: 'full',
  marginTop: '$12',
  position: 'absolute',
  zIndex: ZIndex.TOP,
});

export const StyledOptionsListItem = Pressable.withConfig(
  ({ isHighlighted }: { isHighlighted?: boolean }) => ({
    paddingY: '$3',
    paddingX: '$4',
    borderWidth: 1,
    width: 'full',
    borderColor: getDesignToken('border-color-default'),
    backgroundColor: getDesignToken('background-input'),
    _pressed: {
      backgroundColor: getDesignToken('background-default'),
    },
    _hover: {
      backgroundColor: getDesignToken('background-default'),
    },
    _web: {
      cursor: 'pointer',
      justifyContent: 'center',
    },
    ...(isHighlighted && {
      backgroundColor: getDesignToken('background-default'),
    }),
  })
);
